export function createId(): string {
  const c = (globalThis as { crypto?: Crypto }).crypto
  if (c?.randomUUID) return c.randomUUID()
  return `id_${Date.now().toString(16)}_${Math.random().toString(16).slice(2)}`
}